module.exports = __webpack_public_path__ + "static/media/AP2.ce1fbb67.webp";